import { useState } from "react";
import { ChevronRightIcon } from "@heroicons/react/24/outline";

import { icons } from "~/ui";
import HighlightedText from "~/ui/common/HighlightedText";
import { FAQItem, FAQText } from ".";

export const FAQMobile = () => {
  const [activeSection, setActiveSection] = useState<string | null>(null);
  const [openItems, setOpenItems] = useState<Record<string, boolean>>({});

  const handleSectionClick = (section: string) => {
    setActiveSection(section);
    setOpenItems({});
  };

  const handleBack = () => {
    setActiveSection(null);
  };

  const toggleItem = (index: string) => {
    setOpenItems((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <section className="flex min-h-full flex-col font-sans sm:hidden">
      {!activeSection ? (
        <>
          <header className="p-4">
            <h1 className="text-indigo font-ivy text-4xl">
              <HighlightedText>Frequently asked</HighlightedText>
              <HighlightedText>questions</HighlightedText>
            </h1>
          </header>
          <div className="flex flex-col gap-4 px-4">
            {Object.keys(FAQText).map((section) => (
              <button
                key={section}
                className="text-indigo flex w-full items-center justify-between rounded-lg border border-neutral-400 bg-white px-4 py-4 text-left text-lg font-semibold"
                onClick={() => handleSectionClick(section)}
              >
                {section}
                <ChevronRightIcon className="text-indigo stroke-3 size-5" />
              </button>
            ))}
          </div>
        </>
      ) : (
        <div className="flex flex-1 flex-col">
          <button onClick={handleBack} aria-label="Back" className="mr-2 p-2">
            <icons.outline.ArrowLeftCircleIcon className="text-violet size-10 stroke-1" />
          </button>
          <div className="mb-4 flex items-center px-4">
            <h2 className="font-ivy text-indigo text-3xl">{activeSection}</h2>
          </div>
          <div className="flex-1 px-4">
            {FAQText[activeSection].map((item, idx) => (
              <FAQItem
                key={idx}
                question={item.question}
                answer={item.answer}
                isOpen={!!openItems[idx]}
                onToggle={() => toggleItem(idx.toString())}
              />
            ))}
          </div>
        </div>
      )}
    </section>
  );
};
